import React from 'react';
import { z } from 'zod';
export const SpacerPropsSchema = z.object({
    props: z
        .object({
        height: z.number().gte(0).optional().nullish(),
    })
        .optional()
        .nullable(),
});
export function Spacer({ props }) {
    const style = {
        height: props === null || props === void 0 ? void 0 : props.height,
    };
    return React.createElement("div", { style: style });
}
//# sourceMappingURL=Spacer.js.map